module.exports = __webpack_public_path__ + "media/images/gm_icon03_on-7151b8b630dbd58a5350d55423471f93.png";